/* Venta: first-visit country language, manual selection takes priority. */
(function () {
  'use strict';
  var config = document.getElementById('venta-country-language');
  if (!config) return;
  var current = config.dataset.language;
  var key = 'venta_language_choice_v1';
  function saved() {
    try { return localStorage.getItem(key); } catch (_) { return null; }
  }
  function remember(language) {
    try { localStorage.setItem(key, language); } catch (_) {}
    document.cookie = key + '=' + encodeURIComponent(language) + '; Path=/; Max-Age=31536000; SameSite=Lax; Secure';
  }
  function hasChoice() {
    return saved() || document.cookie.split(';').some(function (c) { return c.trim().indexOf(key + '=') === 0; });
  }
  document.addEventListener('change', function (event) {
    if (event.target.name === 'language_code') remember(event.target.value);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.id === 'venta-country-language-form') return;
    var field = form.querySelector && form.querySelector('[name="language_code"]');
    if (field) remember(field.value);
  }, true);
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a');
    if (!link) return;
    var code = link.getAttribute('data-value');
    if (code === 'en' || code === 'tr') { remember(code); return; }
    var href = link.getAttribute('href');
    if (!href) return;
    try {
      var url = new URL(href, location.href);
      if (url.origin !== location.origin) return;
      var language = /^\/en(?:\/|$)/.test(url.pathname) ? 'en' : 'tr';
      if (language !== current) remember(language);
    } catch (_) {}
  }, true);
  if (hasChoice() || /bot|crawler|spider|slurp|facebookexternalhit|bingpreview/i.test(navigator.userAgent)) return;
  // An explicit English URL or existing English localization is respected.
  if (current === 'en' || /^\/en(?:\/|$)/.test(location.pathname)) { remember('en'); return; }
  if (current !== 'tr') return;
  var controller = new AbortController();
  var timeout = setTimeout(function () { controller.abort(); }, 2500);
  fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') +
    'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false',
    { signal: controller.signal, credentials: 'same-origin' })
    .then(function (response) { if (!response.ok) throw new Error('country unavailable'); return response.json(); })
    .then(function (data) {
      if (hasChoice()) return;
      var country = data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      if (!/^[A-Z]{2}$/.test(country || '')) return;
      if (country === 'TR') { remember('tr'); return; }
      var form = document.getElementById('venta-country-language-form');
      if (!form) return;
      remember('en');
      form.querySelector('[name="language_code"]').value = 'en';
      form.querySelector('[name="return_to"]').value = location.pathname + location.search + location.hash;
      form.submit();
    }).catch(function () {}).finally(function () { clearTimeout(timeout); });
}());